import React from 'react';
import styled, { useTheme } from 'styled-components';
import { SolvTheme, SolvThemeType } from '../../theme/theme';

type SpinnerProps = {
  color?: keyof typeof SolvTheme.colors;
  size?: keyof typeof SolvTheme.fontSizes;
};

const Root = styled.div<{ color: string; size: string }>`
  display: inline-block;
  position: relative;
  width: calc(${({ size }) => size} * 1.25);
  height: calc(${({ size }) => size} * 1.25);

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    margin: 3px;
    border: 3px solid ${({ color }) => color};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ color }) => color} transparent transparent transparent;
  }

  & div:nth-child(1) {
    animation-delay: -0.45s;
  }

  & div:nth-child(2) {
    animation-delay: -0.3s;
  }

  & div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = ({ color = 'gray-200', size = '3xl' }: SpinnerProps) => {
  const theme = useTheme() as SolvThemeType;

  const cssColor = theme.colors[color] ?? color;
  const cssSize = theme.fontSizes[size];

  return (
    <Root color={cssColor} size={cssSize}>
      <div />
      <div />
      <div />
      <div />
    </Root>
  );
};

Spinner.displayName = 'Spinner';
export default Spinner;
